<template>
  <div class="home">
    <div class="nav centent clearfix">
      <div class="fl" style="width: 20%">
        <img
          src="../assets/img/logo.png"
          alt=""
          style="width: 40%; vertical-align: middle"
          @click="$commonData.toPage('/')"
        />
      </div>
      <div class="fl" style="width: 60%">
        <ul>
          <li
            @mouseover="navbtn(1)"
            :class="{ listyle: navnum == 1 }"
            @click="$commonData.toPage('/')"
          >
            <span :class="{ nav_span: navnum == 1 }">首页 </span>
          </li>
          <li @mouseover="navbtn(2)" :class="{ listyle: navnum == 2 }">
            <span :class="{ nav_span: navnum == 2 }"  @click="$commonData.toPage('/about')"
              >关于我们</span
            >
          </li>
          <li
            @mouseover="navbtn(3)"
            :class="{ listyle: navnum == 3 }"
            @click="$commonData.toPage('/newpage')"
          >
            <span :class="{ nav_span: navnum == 3 }">新闻资讯</span>
          </li>
          <li @mouseover="navbtn(4)" :class="{ listyle: navnum == 4 }">
            <span :class="{ nav_span: navnum == 4 }" @click="mddw(2)"
              >课程优势</span
            >
          </li>
          <li
            @mouseover="navbtn(5)"
            :class="{ listyle: navnum == 5 }"
            @click="mddw(3)"
          >
            <span :class="{ nav_span: navnum == 5 }">平台功能</span>
          </li>
          <li
            @mouseover="navbtn(6)"
            :class="{ listyle: navnum == 6 }"
            @click="mddw(4)"
          >
            <span :class="{ nav_span: navnum == 6 }">产品体系</span>
          </li>
          <li @mouseover="navbtn(7)" :class="{ listyle: navnum == 7 }"  @click="$commonData.toPage('/contactus')">
            <span :class="{ nav_span: navnum == 7 }">联系我们</span>
          </li>
        </ul>
      </div>
      <div class="fr ewm" @mouseover="over" @mouseleave="leave">微信公众号</div>
      <div class="show" id="show" v-if="showFlag">
        <span class="out"></span>
        <img src="https://www.gsyfpxy.com/assets/img/pc/home/er.png" alt="" />
        <p>扫码微信学习</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showFlag: false,
      navnum: 0,
    };
  },
  methods: {
    navbtn(num) {
      this.navnum = num;
    },
    over() {
      this.showFlag = true;
    },
    leave() {
      this.showFlag = false;
    },
    // 锚点定位
    mddw(num) {
      if (this.$route.path == "/") {
        this.$emit("mddw", num);
      } else {
        this.$commonData.toPage("/", { flagtz: true, index: num });
      }
    },
  },
};
</script>
<style  src='../assets/css/home.css'>
</style>
